import React, { Component } from 'react';
import Logotip from './Logotip/Logotip';
import Header from './Header/Header';
import { Nav, Button } from 'react-bootstrap';
import Navbar from './Navbar/Navbar';

export default class Navigation extends Component {
  render() {
    return (
      <Nav
        className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top"
        id="mainNav"
      >
        {/* Логотип */}
        <Logotip />
        {/* Кнопка гамбургер меню */}
        <Button
          className="navbar-toggler navbar-toggler-right"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </Button>

        {/* Гамбургер анимация при разных экранах */}
        <div className="collapse navbar-collapse" id="navbarResponsive">
          {/* Общий див верхней и левой навигации */}
          <Navbar />
          <Header />
        </div>
      </Nav>
    );
  }
}
